var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "addLicenseModal",
      "centered": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "addLicense-header text-center"
        }, [_c('h4', [_vm._v("Add License")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "addLicense-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "addLicenseContainer",
          on: {
            "submit": function submit($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.addLicense);
            }
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('input-select', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "state",
            "labelName": "State",
            "inputName": "state",
            "vmodel": _vm.form.state,
            "options": _vm.states,
            "defaultOption": "Select Your State",
            "formGroupClass": "col-xxl-6 col-lg-6 col-md-6 mb-3",
            "inputClass": "form-control"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "state", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: true,
              regex: /^[a-zA-Z0-9]*$/
            },
            "labelFor": "license_number",
            "labelName": "License Number",
            "inputName": "license_number",
            "vmodel": _vm.form.license_number,
            "input-type": "text",
            "formGroupClass": "col-xxl-6 col-lg-6 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "license_number", $event);
            }
          }
        })], 1), _c('div', {
          staticClass: "form-group row"
        }, [_c('div', {
          staticClass: "col-xxl-6 col-lg-6 col-md-6 mb-3"
        }, [_c('validation-provider', {
          attrs: {
            "name": "License Valid Until",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var errors = _ref2.errors,
                  valid = _ref2.valid;
              return [_c('label', {
                attrs: {
                  "for": ""
                }
              }, [_vm._v(" License Valid Until "), _c('span', {
                staticClass: "required-indc"
              }, [_vm._v("*")])]), _c('br'), _c('date-picker', {
                attrs: {
                  "input-class": _vm.getDatePickerClass(errors[0], valid),
                  "placeholder": "License Valid Until",
                  "type": "date",
                  "value-type": "format",
                  "default-value": new Date(),
                  "disabled-date": _vm.disabledBeforeToday
                },
                model: {
                  value: _vm.form.license_exp_date,
                  callback: function callback($$v) {
                    _vm.$set(_vm.form, "license_exp_date", $$v);
                  },
                  expression: "form.license_exp_date"
                }
              }), _c('span', {
                staticClass: "invalid-date invalid-feedback"
              }, [_vm._v(" " + _vm._s(errors[0]) + " ")])];
            }
          }], null, true)
        })], 1), _c('input-multi-select', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "resident",
            "labelName": "Resident",
            "inputName": "resident",
            "vmodel": _vm.form.license_resident,
            "options": _vm.residents.map(function (type) {
              return type.value;
            }),
            "custom-label": function customLabel(opt) {
              return _vm.residents.find(function (x) {
                return x.value == opt;
              }).text;
            },
            "formGroupClass": "col-xxl-6 col-lg-6 col-md-6 mb-3",
            "placeholder": "Select Option"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "license_resident", $event);
            }
          }
        })], 1), _c('div', {
          staticClass: "form-group row"
        }, [_c('input-file', {
          ref: "licenseFileInput",
          attrs: {
            "rules": {
              mimes: _vm.mimeTypes,
              size: 5120
            },
            "labelFor": "license_doc",
            "labelName": "Upload License File(PDF,JPG or PNG)",
            "inputName": "license_doc",
            "vmodel": _vm.form.license_doc,
            "acceptMimeTypes": _vm.mimeTypes,
            "formGroupClass": "col-xxl-12 col-lg-12 col-md-12 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "license_doc", $event);
            }
          }
        })], 1), _c('div', {
          staticClass: "form-group text-center mb-3 mt-3"
        }, [_c('b-button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit",
            "disabled": _vm.isCreate
          }
        }, [_vm.isCreate ? [_vm._v(" Adding ... ")] : [_vm._v(" Add ")]], 2)], 1)])];
      }
    }])
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }